/* tslint:disable */
/* eslint-disable */
/**
 * My Title
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface InspectionReassignResponse
 */
export interface InspectionReassignResponse {
    /**
     * 
     * @type {number}
     * @memberof InspectionReassignResponse
     */
    movedInspectionId?: number;
    /**
     * 
     * @type {number}
     * @memberof InspectionReassignResponse
     */
    fromAssetId?: number;
    /**
     * 
     * @type {number}
     * @memberof InspectionReassignResponse
     */
    toAssetId?: number;
    /**
     * 
     * @type {number}
     * @memberof InspectionReassignResponse
     */
    movedObservationCount?: number;
    /**
     * 
     * @type {string}
     * @memberof InspectionReassignResponse
     */
    note?: string;
    /**
     * 
     * @type {boolean}
     * @memberof InspectionReassignResponse
     */
    regenerationHint?: boolean;
}

/**
 * Check if a given object implements the InspectionReassignResponse interface.
 */
export function instanceOfInspectionReassignResponse(value: object): value is InspectionReassignResponse {
    return true;
}

export function InspectionReassignResponseFromJSON(json: any): InspectionReassignResponse {
    return InspectionReassignResponseFromJSONTyped(json, false);
}

export function InspectionReassignResponseFromJSONTyped(json: any, ignoreDiscriminator: boolean): InspectionReassignResponse {
    if (json == null) {
        return json;
    }
    return {
        
        'movedInspectionId': json['movedInspectionId'] == null ? undefined : json['movedInspectionId'],
        'fromAssetId': json['fromAssetId'] == null ? undefined : json['fromAssetId'],
        'toAssetId': json['toAssetId'] == null ? undefined : json['toAssetId'],
        'movedObservationCount': json['movedObservationCount'] == null ? undefined : json['movedObservationCount'],
        'note': json['note'] == null ? undefined : json['note'],
        'regenerationHint': json['regenerationHint'] == null ? undefined : json['regenerationHint'],
    };
}

export function InspectionReassignResponseToJSON(json: any): InspectionReassignResponse {
    return InspectionReassignResponseToJSONTyped(json, false);
}

export function InspectionReassignResponseToJSONTyped(value?: InspectionReassignResponse | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'movedInspectionId': value['movedInspectionId'],
        'fromAssetId': value['fromAssetId'],
        'toAssetId': value['toAssetId'],
        'movedObservationCount': value['movedObservationCount'],
        'note': value['note'],
        'regenerationHint': value['regenerationHint'],
    };
}

